import { render, staticRenderFns } from "./Tambah.vue?vue&type=template&id=137bfe5c&scoped=true&"
import script from "./Tambah.vue?vue&type=script&lang=js&"
export * from "./Tambah.vue?vue&type=script&lang=js&"
import style0 from "./Tambah.vue?vue&type=style&index=0&id=137bfe5c&lang=scss&scoped=true&"
import style1 from "./Tambah.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137bfe5c",
  null
  
)

export default component.exports